export default "__VITE_ASSET__Dmh_oR$f__"